import React from 'react';
import { Box, Typography } from '@mui/material';
import { SavingsOutlined, TrendingDown } from '@mui/icons-material';

const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const index = ({ year, month, savings, pct }) => {
  const monthName = month != null ? MONTH_NAMES[month - 1] ?? month : null;
  const savingsDisplay = savings != null
    ? `$${Number(savings).toLocaleString("en-US", { maximumFractionDigits: 0 })}`
    : "$–";
  const pctDisplay = pct != null
    ? `${Number(pct).toFixed(1)}%`
    : null;

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
    }}>
      {/* Content box */}
      <Box sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 3,
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--c-accent-bg)",
          color: "var(--c-brand)",
        }}>
          <SavingsOutlined />
        </Box>

        {/* Month / Year label */}
        {monthName && year && (
          <Typography sx={{
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: "var(--c-text-muted)",
            lineHeight: 1,
          }}>
            {`${monthName} ${year}`}
          </Typography>
        )}

        {/* Savings amount */}
        <Typography
          sx={{
            color: savings != null ? "var(--c-brand)" : "var(--c-border-strong)",
            fontWeight: 700,
            fontSize: 48,
            lineHeight: 1,
            letterSpacing: "-0.02em",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {savingsDisplay}
        </Typography>

        {/* Percentage of total bill */}
        {pctDisplay && (
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            px: 1.25,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: "var(--c-success-bg)",
            color: "var(--c-success)",
          }}>
            <TrendingDown sx={{ fontSize: 16 }} />
            <Typography sx={{ fontSize: 13, fontWeight: 600, lineHeight: 1 }}>
              {`${pctDisplay} of total bill`}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Footer box */}
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 2.5,
        py: 1.75,
        borderTop: "1px solid var(--c-border)",
        backgroundColor: "var(--c-subtle)",
      }}>
        <Typography sx={{ color: "var(--c-text-3)", fontSize: 13, fontWeight: 500 }}>
          {"Lifetime savings"}
        </Typography>
        <Typography sx={{ color: "var(--c-brand)", fontWeight: 700, fontSize: 20, lineHeight: 1 }}>
          {"$–"}
        </Typography>
      </Box>
    </Box>
  )
}

export default index;
